<template>
  <div class="ezuikit-js">
    <div class="video-wrapper">
      <div id="video-container"></div>
      <div v-if="isLoading" class="loading-overlay">
        <div class="loading-spinner"></div>
        <div class="loading-text">加载中...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { EZUIKitPlayer } from "ezuikit-js";
import EventBus from '@/utils/eventBus'
var player = null;

export default {
  name: "Player",
  data() {
    return {
      carStatus: false,
      accessToken: '',
      videoUrl: '',
      isLoading: true,
      initTimer: null,
    }
  },
  mounted() {
    console.group("mounted 组件挂载完毕状态===============》");
    EventBus.$on('videoInfo', this.handleVideoInfo);
    EventBus.$on('carStatus', this.handleCarStatus);
  },
  beforeDestroy() {
    EventBus.$off('videoInfo', this.handleVideoInfo);
    EventBus.$off('carStatus', this.handleCarStatus);
    if (this.initTimer) {
      clearTimeout(this.initTimer);
      this.initTimer = null;
    }
    if (player) this.destroy();
  },
  methods: {
    handleVideoInfo(data) {
      this.accessToken = data.accessToken;
      this.videoUrl = data.videoUrl;
      console.log('Received video info:', this.accessToken, this.videoUrl);
        console.log(this.accessToken  + this.videoUrl)
      if ( this.accessToken && this.videoUrl) {
        console.log(this.videoUrl)
        if (this.initTimer) clearTimeout(this.initTimer);
        this.initTimer = setTimeout(() => {
          this.initTimer = null;
          this.$nextTick(() => {
            if (typeof window.requestAnimationFrame === 'function') {
              window.requestAnimationFrame(() => this.init());
            } else {
              this.init();
            }
          });
        }, 300);
      } else if ( (!this.accessToken || !this.videoUrl)) {
        this.showToast('车辆摄像头未打开');
      }
    },
    handleCarStatus(status) {
      this.carStatus = status;
    
    },
    showToast(message) {
      if (typeof uni !== 'undefined') {
        uni.showToast({
          title: message,
          icon: 'none'
        });
      } else {
        alert(message);
      }
    },
    init() {
      if (player) {
        this.destroy();
      }
      this.isLoading = true;
      const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      player = new EZUIKitPlayer({
        id: "video-container", // 视频容器ID
        accessToken:
          this.accessToken,
        url: this.videoUrl,
        // simple: 极简版; pcLive: pc直播; pcRec: pc回放; mobileLive: 移动端直播; mobileRec: 移动端回放;security: 安防版; voice: 语音版;
        template: "simple",
        plugin: ["talk"], // 加载插件，talk-对讲
        width:   "100%",
        height: "100%",
        audio: false,
        enableSharedArrayBufferGuide: false,
        talkChannelNo: 0,
        useHardDev: true,
        handleError: (error) => {
          console.error("handleError", error);
          this.isLoading = false;
        },
        // quality: 1, // 
        // language: "en", // zh | en
        // staticPath: "/ezuikit_static", // 如果想使用本地静态资源，请复制根目录下ezuikit_static 到当前目录下， 然后设置该值
        // isCloudRecord: true, // 如果是云录制的播放 需要这个值，是必须的, 8.2.0 开始 默认支持
        scaleMode: 0, // 默认 0 完全填充窗口，会有拉伸 1: 等比适配 2: 等比完全填充窗口, 超出隐藏 @sine 8.2.0
        env: {
          // https://open.ys7.com/help/1772?h=domain
          // domain默认是 https://open.ys7.com, 如果是私有化部署或海外的环境，请配置对应的domain
          // The default domain is https://open.ys7.com If it is a private deployment or overseas (outside of China) environment, please configure the corresponding domain
          domain: "https://open.ys7.com",
        },
        // staticPath:"https://openstatic.ys7.com/ezuikit_js/v8.1.9/ezuikit_static",
        // 日志打印设置
        showStreamInfo: false,
        // 视频流的信息回调类型
        /**
         * 打开流信息回调，监听 streamInfoCB 事件
         * 0 : 每次都回调
         * 1 : 只回调一次
         * 注意：会影响性能
         * 默认值 1
         */
        streamInfoCBType: 1,
        // v8.1.10
        // 自定义清晰度 默认 null, 如果有值 sdk 内部不在进行获取, null 默认使用接口获取的清晰度列表, videoLevelList.length === 0 不展示清晰度控件 sdk 内部不在进行获取, videoLevelList.length > 0 展示控件 sdk 内部不在进行获取
        // videoLevelList: [
        //   { level: 1, name: "标清", streamTypeIn: 2 }, // 需要保证支持子码流 (streamTypeIn=2)
        //   { level: 2, name: "高清", streamTypeIn: 1 },
        // ],
        // videoLevelList: [
        //   { level: -1, name: "标清", streamTypeIn: 2 }, // 8.1.17 开始 当 level 的值小于 0时， 不在向设备发送指令，仅根据 streamTypeIn 切换码流 （请保证 streamTypeIn 对应的码流存在）
        //   { level: -2, name: "高清", streamTypeIn: 1 }, // 8.1.17 开始 当 level 的值小于 0时， 不在向设备发送指令，仅根据 streamTypeIn 切换码流 （请保证 streamTypeIn 对应的码流存在）
        // ]
      });

      player.eventEmitter.on(EZUIKitPlayer.EVENTS.videoInfo, (info) => {
        console.log("videoinfo", info);
      });

      player.eventEmitter.on(EZUIKitPlayer.EVENTS.audioInfo, (info) => {
        console.log("audioInfo", info);
      });

      // 首帧渲染成功
      // first frame display
      player.eventEmitter.on(
        EZUIKitPlayer.EVENTS.firstFrameDisplay,
        () => {
          console.log(" 加载成功");
          this.isLoading = false;
        }
      );
      player.eventEmitter.on(
        EZUIKitPlayer.EVENTS.streamInfoCB,
        (info) => {
          console.log("streamInfoCB ", info);
        }
      );

      window.player = player;
    },
    play() {
      var playPromise = player.play();
      playPromise.then((data) => {
        console.log("promise 获取 数据", data);
      });
    },
    stop() {
      var stopPromise = player.stop();
      stopPromise.then((data) => {
        console.log("promise 获取 数据", data);
      });
    },
    getOSDTime() {
      var getOSDTimePromise = player.getOSDTime();
      getOSDTimePromise.then((data) => {
        console.log("promise 获取 数据", data);
      });
    },
    capturePicture() {
      var capturePicturePromise = player.capturePicture(
        `${new Date().getTime()}`
      );
      capturePicturePromise.then((data) => {
        console.log("promise 获取 数据", data);
      });
    },
    openSound() {
      var openSoundPromise = player.openSound();
      openSoundPromise.then((data) => {
        console.log("promise 获取 数据", data);
      });
    },
    closeSound() {
      var openSoundPromise = player.closeSound();
      openSoundPromise.then((data) => {
        console.log("promise 获取 数据", data);
      });
    },
    startSave() {
      var startSavePromise = player.startSave(`${new Date().getTime()}`);
      startSavePromise.then((data) => {
        console.log("promise 获取 数据", data);
      });
    },
    stopSave() {
      var stopSavePromise = player.stopSave();
      stopSavePromise.then((data) => {
        console.log("promise 获取 数据", data);
      });
    },
    startTalk() {
      player.startTalk();
    },
    stopTalk() {
      player.stopTalk();
    },
    fullScreen() {
      player.fullScreen();
    },
    destroy() {
      var destroyPromise = player.destroy();
      destroyPromise.then((data) => {
        console.log("promise 获取 数据", data);
      });
      player = null;
    },
  },
};
</script>

<style scoped>
.ezuikit-js {
  width: 100%;
  height: 100%;
}

.video-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
}

#video-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 10px;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.3);
	border-top-color: #35d39a;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loading-text {
  color: #ffffff;
  font-size: 14px;
  margin-top: 12px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
